import { FormStateType } from "../../../../types";
import { FILE_ATTACHMENTS_CONSTANTS } from "../../../constants";

export const formState: FormStateType = {
  [FILE_ATTACHMENTS_CONSTANTS.PHOTOS]: {
    value: [],
    errors: [],
    hidden: false,
  },
  [FILE_ATTACHMENTS_CONSTANTS.DOCUMENTS]: {
    value: [],
    errors: [],
    hidden: false,
  },
};
